import Action from "../../classes/Action";
import { isTangible, JsonCopy } from "../../classes/utilities/Misc";
import AssetsLibraryUtilities from "../../components/filebrowser/AssetsLibraryUtilities";
import { IVisageTemplate } from "../../interfaces/VisageUI";
import store, { StoreActions } from '../../state/store';

export default class ReplaceUITemplateAction extends Action
{
	constructor(oldTemplateId: string, newTemplateId: string)
	{
		const oldTemplateData = JsonCopy<IVisageTemplate>(store.getState().visageModule.uiTemplateData[oldTemplateId] ?? {} as IVisageTemplate);
		const newTemplateData = JsonCopy<IVisageTemplate>(store.getState().visageModule.uiTemplateData[newTemplateId] ?? {} as IVisageTemplate);

		// collect affected steps
		const stepsToReplace = new Array<string>();
		for(const [stepId, templateId] of Object.entries<string>(store.getState().visageModule.stepTemplateMap))
		{
			if(templateId === oldTemplateId)
			{
				stepsToReplace.push(stepId);
			}
		}

		super(
			[stepsToReplace, newTemplateId],
			[stepsToReplace, oldTemplateId],
			`Replacing ${oldTemplateData.name} UI template with ${newTemplateData.name}`,
			[oldTemplateData, newTemplateData]
		);
	}

	do(stepsToReplace: string[], targetTemplateId: string)
	{
		const targetTemplateData = store.getState().visageModule.uiTemplateData[targetTemplateId];

		for(const stepId of stepsToReplace)
		{			
			store.dispatch(StoreActions.visage.setStepTemplate({ stepId: stepId, templateId: targetTemplateId }));
			store.dispatch(StoreActions.visage.setStepUIData({ stepId: stepId, data: JsonCopy(targetTemplateData.content) }));
		}

		AssetsLibraryUtilities.refresh();
	}

	verify(oldTemplateData: IVisageTemplate, newTemplateData: IVisageTemplate)
	{
		return isTangible(oldTemplateData) && isTangible(newTemplateData) && oldTemplateData.id !== "" && oldTemplateData.id !== newTemplateData.id;
	}
}
